export const ABNORMAL_ORGAN_VOLUME_CONDITION = 'abnormal_organ_volume' as const;
